<template>
    <div>
        <!-- <iframe :src="iframeSrc" style="display: none"></iframe> -->
        <a id="target" :href="iframeSrc" style="display: none"></a>
        <el-button type="primary" icon="icon-action-undo" @click="clickExport()" v-loading.fullscreen.lock="fullscreenLoading"> {{$t('m.exportResults')}} </el-button>
        <el-dialog
            :title="$t('m.chooseExpNum')"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="dialog-content">
                <el-radio-group v-model="currentPage" style="width: 90%">
                    <el-row :gutter="20">
                        <el-col :span="6" style="margin: 10px 0 " v-for="item in pageArr" :key="item"><el-radio :label="item">第{{item}}个{{pageSize}}条</el-radio></el-col>
                    </el-row>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" @click="exportPage()">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props:['total', 'exportType', 'exportUrl'],
    data() {
        return {
            iframeSrc: '',
            dialogVisible: false,
            pageSize: 1000,
            currentPage: 1,
            pages: 1,
            pageArr: [],
            fullscreenLoading: false
        }
    },
    methods: {
        clickExport() {
            console.log('exportType: %s',this.exportType)
            console.log('total: %s',this.total)
            if(this.total) {
                if(this.exportType == 'choose') {
                    this.iframeSrc = this.exportUrl + '&t=' + Date.now()
                    setTimeout(()=>{
                        document.getElementById("target").click()
                    }, 1000)
                    this.fullscreenLoading = true
                    setTimeout(() => {
                      this.fullscreenLoading = false
                    }, 2000)
                } else {
                    this.pageArr = []
                    this.pages = Math.ceil(this.total/this.pageSize)
                    for(let i = 1 ; i <= this.pages; i++) {
                        this.pageArr.push(i)
                    }
                    this.dialogVisible = true
                }
            } else {
                this.$message.info(this.$t('m.noData'))
            }
        },
        exportPage() {
            console.log("export url %s",this.exportUrl)
            this.iframeSrc = this.exportUrl 
            + '&pageSize=' + this.pageSize
            + '&pageNum=' + this.currentPage
            + '&t=' + Date.now()
            this.dialogVisible = false
            this.$requestService.downloadFile(this.iframeSrc)
            .then(res=>{
                this.fullscreenLoading = true
                setTimeout(()=>{
                    document.getElementById("target").click()
                }, 1000)
                setTimeout(() => {
                    this.fullscreenLoading = false
                }, 2000)
            })
            .catch(res=>{
                this.$message.error(res.message)
            })    
        }
    },

}
</script>



// WEBPACK FOOTER //
// src/components/common/LapExportBtn.vue